// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9EGds","image":"Header_image__2rVNV","name":"Header_name__1y8TA","info":"Header_info__IrY7G","infoRow":"Header_infoRow__34DKQ"};